<template>
    <div class="container-fluid" id="about" v-if="show">
        <div class="eyecatch">
            <img src="/img/about/01.jpg" alt="アイキャッチ" class="img-fluid mx-auto d-block about" />
        </div>
        <div class="container mincho">
            <links></links>
            <h2 class="text-center">貸し本棚とは</h2>
            <div class="desc">
                <p>
                    「貸し本棚」は、小説を書くこと、読むことにフォーカスした小説展示サイトです。
                </p>
                <p>
                    ポイントも無ければランキングもありません。
                    貸し本棚は、あなたの作品を宣伝しません。
                    その代わり、他の作品や、他の作者と比べたり、競い合わせたりしません。
                    また、あなたの作品を削除することはありません。
                </p>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <h4>小説を執筆して展示する</h4>
                    <p>
                        小説を書く目的は人それぞれですが、誰しも自分自身の作品を一番愛していると思います。
                        良い作品が書けたとき、それを誰かに読んでもらいたい、評価を得たいと思うことに不思議はありません。
                        それを実現するサービスは既にたくさんあります。
                    </p>
                    <p>
                        「貸し本棚」は多くの読者に作品をお届けする一般的な投稿サイトではなく、
                        原本を執筆するワークスペースであり、作品を展示するショーケースです。
                        宣伝するもしないも作家様次第です。
                    </p>
                    <p>
                        作家様専用のドメイン直下に、あなたの作品だけがリストされます。
                        作家様の本棚は、いま見ている貸し本棚ポータルの一部ではなく、独立したサイトのように見えるでしょう。
                    </p>
                </div>
                <div class="col-md-4">
                    <h4>自分の作品に没頭する</h4>
                    <p>
                        エディタで書いた本文をコピペしたり、既存作品を一括でアップロードすることもできますが、
                        貸し本棚自体が強力な執筆機能を備えています。
                    </p>
                    <p>
                        ひとたび執筆を開始すると、本文とエピソードタイトル以外のコントロールはすべて非表示になり、
                        いま書いている作品以外のことに心を煩わせることはありません。
                    </p>
                    <p>
                        機能面は「<router-link to="/about/write">小説を書く</router-link>」を参照してください。
                        執筆に必要な機能はほとんど揃っています。
                        作品を横断検索し、エピソードをバージョン管理し、梗概や設定資料を書き、
                        百話を超えるエピソード数であっても、一定間隔の公開日時を瞬時に一括設定できます。
                    </p>
                </div>
                <div class="col-md-4">
                    <h4>耽読の没入感</h4>
                    <p>
                        小説投稿サイトでは、エピソードの終わりに類似する他のオススメ作品や企画バナー、広告、
                        感想欄や評価ボタンなどが表示されます。サービスを盛り上げるために必要な機能です。
                    </p>
                    <p>
                        貸し本棚は読書に関係のない要素はほとんど表示しません。
                        作者様が設置した拍手ボタン以外は、戻るリンクと進むリンク、目次等のサイドメニューボタンしかありません。
                        耽読する読者様の気分を妨げる要素は極力排しています。
                    </p>
                    <p>
                        本文ページは横書きだけでなく縦書き、文字サイズ、背景色を変更できるだけでなく、
                        一般的なリーディングトラッカーや、ノベルゲームのような文字打ち機能を備えます。
                        一度読んだ作品は自動的に履歴に保存され「続きから読む」で読書を再開できます。
                    </p>
                </div>
            </div>
            <h3 class="caption">
                <span class="badge badge-primary">執筆する</span>
                エピソードを横断できるエディタ
            </h3>
            <div class="row">
                <div class="col-md-4">
                    <p>
                        貸し本棚の小説執筆エディタは、小説を執筆するのに必要な機能を備えています。
                        視認性が高く文芸的雰囲気を阻害しない明朝体で本文を編集でき、
                        ルビや傍点をワンタップ（あるいはショートカット）で入力できます。
                        PCは勿論、タブレットやスマートフォンでも同一の機能を利用できます。
                    </p>
                    <p>
                        小説はすぐに書き始められます。<br>
                        マイページでサブドメインを決めたら、新規小説を作成し、本文を追加してください。
                    </p>
                    <p>
                        未公開の作品を執筆するときは、執筆した内容は自動保存されます。
                        間違えてブラウザを閉じてしまっても、本文が失われることはありません。<br>
                        執筆中の本文は、リアルタイムにプレビューすることができ、実画面のプレビューも可能です。
                    </p>
                </div>
                <div class="col-md-8">
                    <img v-lazy="'/img/about/02.png'" class="img-fluid img-desc mx-auto d-block" />
                </div>
            </div>
            <h3 class="caption text-right">
                <span class="badge badge-danger">設計する</span>
                執筆のための資料
            </h3>
            <div class="row">
                <div class="col-md-7">
                    <img v-lazy="'/img/about/03.png'" class="img-fluid img-desc mx-auto d-block" />
                </div>
                <div class="col-md-5">
                    <p>
                        執筆に必要となる梗概、登場人物のリスト、用語集、設定資料などを、
                        小説本文とは別に「ノート」として記述することができます。
                        これらのノートは、執筆中の本文に並べて表示することができ、いつでも加筆、修正することができます。
                    </p>
                    <p>
                        アイデアだけを書き留めたいですか？
                    </p>
                    <p>
                        貸し本棚のノートは、小説本文を追加しなくても、それ単体で作成することができます。
                        小説を追加して、ノートの編集からノートを追加して、アイデアを忘れないうちに書き留めておくことができます。
                    </p>
                    <p>
                        ノートはブロックエディタで、自由にフォーマットを変更することができます。
                        「こう使わないといけない」というルールはありません。
                        作家さんが普段書いている資料の作り方で、そのまま記述することができます。
                        小説をバックアップするとき、これらのノートも併せてバックアップされます。
                    </p>
                </div>
            </div>
            <h3 class="caption">
                <span class="badge badge-primary">保管する</span>
                数百話の過去作も一瞬で
            </h3>
            <div class="row">
                <div class="col-md-5">
                    <p>
                        複数の投稿サイトに散らばった過去作品を一箇所にまとめたいですか？
                    </p>
                    <p>
                        貸し本棚は小説の全文が記載されたテキストファイルをアップロードすることで、
                        指定されたルールに基づき、エピソード分解を処理します。
                        小説家になろう形式であれば、テキストファイルを加工することなく、
                        瞬時にアップロードすることができます。
                    </p>
                    <p>
                        目下、執筆中の作品があれば、貸し本棚にアップロードしてください。
                        メモ帳やアウトラインエディタよりも小説の執筆に集中できる環境で、
                        作業を続行することができます。
                        電車で移動中にスマホで執筆し、帰宅してからパソコンで続きを執筆することもできます。
                    </p>
                    <p>
                        作品の表紙絵もアップロードすることができます。
                        貸し本棚の表紙絵の表示域は比較的広いため、タイトル文字が潰れてみえなくなることはほとんどありません。
                    </p>
                </div>
                <div class="col-md-7">
                    <img v-lazy="'/img/about/05.png'" class="img-fluid img-desc mx-auto d-block" />
                </div>
            </div>
            <h3 class="caption text-right">
                <span class="badge badge-danger">集める</span>
                作家さんのポートフォリオとして
            </h3>
            <div class="row">
                <div class="col-md-7">
                    <img v-lazy="'/img/about/04.png'" class="img-fluid img-desc mx-auto d-block" />
                </div>
                <div class="col-md-5">
                    <p>
                        貸し本棚には投稿サイトにつきものの「トレンド」という概念がありません。
                        ポイントもランキングも公開制限もないサイトで、
                        あなたの作品はひとつの本棚に集約されます。
                        他の作家さんの作品と混ざることなく、一箇所に集められた作品群は、
                        あなたのポートフォリオとして、あるいは隠れ家として、SNSで宣伝するときに役立ちます。
                    </p>
                    <p>
                        余計な情報の無いランディングページがひとつ用意されていることで、
                        あなたの読者は作品をみつけやすくなります。
                        貸し本棚の作品ページには、その作品が公開されている別の投稿サイトへのリンクを複数設置することができます。
                        どの作品がどこで公開されているかを示すことにより、
                        読者は作家さんの最新作を追いかけることが可能になります。
                    </p>
                    <p>
                        多作の作家さんであれば、本棚のページで、推薦したいピックアップ作品をアイキャッチの下に表示することもできます。
                        多くの作品のどれから読めば良いか、読者の選択の手助けになります。
                    </p>
                    <p>
                        <b>作品の投稿が面倒ですか？</b><br>
                        問題ありません。様々な小説投稿サイトに掲載されたあなたの作品へのURLをコピペするだけで、
                        XやblueskyにURLを貼り付けたときと同じカードを作成し、その他の投稿作品と共に本棚に並べることもできます。
                    </p>
                </div>
            </div>
            <div class="mt-5">
                <links></links>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.eyecatch {
    background-color: #E0E0E0;
}
.about {
    max-height: 640px;
}
.desc {
    font-size: 1.1rem;
    margin-bottom: 2.5rem;
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
}
.caption {
    margin: 3rem 0 .8rem;
    padding: .5rem 0;
    border-bottom: 1px dashed #ddd;
}
.img-desc {
    border: 1px solid #ddd;
    border-radius: .2rem;
}
.img-tips {
    width: 350px;
    height: 350px;
}
.img-icon {
    object-fit: cover;
    width: 64px;
    height: 64px;
}
.icon-column {
    max-width: 64px;
}
.small-caption {
    font-weight: bold;
    text-align: center;
    margin-top: 2rem;
}
#about {
    padding-right: 0px;
    padding-left: 0px;
    h2 {
        margin-top: 5rem;
        margin-bottom: 1rem;
    }
}
</style>

<script>
import links from "./links";
export default {
    components: {
        links
    },
    data() {
        return {
            show: true
        }
    },
    mounted() {
        this.useHead({
            title: "貸し本棚とは | 貸し本棚",
            link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ]
        });
    }
}
</script>